function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';
import { Button } from "../Button";

class Buttongroup extends Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "renderButton", (button, index) => {
      const buttonType = this.props.buttonType;
      const children = button.children;

      if (children) {
        return React.createElement(Buttongroup, _extends({}, this.props, {
          key: index,
          buttongroup: children
        }));
      }

      return React.createElement(Button, _extends({}, button, {
        type: buttonType,
        key: index
      }));
    });

    _defineProperty(this, "getClassName", () => {
      const _this$props = this.props,
            className = _this$props.className,
            type = _this$props.type;

      if (className) {
        return className;
      }

      let classNames = [];
      classNames.push('admin-buttongroup');

      if (type) {
        classNames.push('admin-buttongroup--' + type);
      }

      return classNames.join(' ');
    });
  }

  render() {
    const _this$props2 = this.props,
          buttongroup = _this$props2.buttongroup,
          dataType = _this$props2.dataType;
    const className = this.getClassName();

    if (buttongroup) {
      return React.createElement("div", {
        className: className,
        "data-type": dataType
      }, buttongroup.map(this.renderButton));
    }

    return React.createElement("div", {
      className: className,
      "data-type": dataType
    }, this.props.children);
  }

}

_defineProperty(Buttongroup, "defaultProps", {
  buttongroup: false
});

export default Buttongroup;